import { FC } from "react";
import "./ExistingClubTag.scss";
interface IExistingClubTagProps {
  tagName: string;
  isFilterTag?: boolean;
  isFilterActive?: boolean;
  changeSelectedFilter?: () => void;
  addTagHandler?: ({ label, value }, isActive?: boolean) => void;
}

const ExistingClubTag: FC<IExistingClubTagProps> = ({
  tagName,
  isFilterTag,
  isFilterActive,
  changeSelectedFilter,
}) => {
  return (
    <div
      onClick={changeSelectedFilter}
      className={
        isFilterTag && isFilterActive
          ? "existing-club-tag existing-club-tag--active"
          : "existing-club-tag"
      }
    >
      <p className="existing-club-tag__name">{tagName}</p>
    </div>
  );
};

export default ExistingClubTag;
